export function CustomSurveyJS({ id, onCreate, onModify, onDelete }) {
    return (
        <>
            <div>CustomSurveyJS</div>
            <p>{id}</p>
        </>
    )
}
